import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * IoT Module Service Stores
 * Services for IoT device management and data collection
 */
export const iotStores: ServiceStoreConfig[] = [
  {
    name: "azure-iot-hub",
    options: {
      enableStorage: false,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.azureIotHubStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalDevices = entities.length;
          const connectedDevices = entities.filter(
            (device: Record<string, unknown>) =>
              device.status === "connected" || device.connectionState === "connected"
          ).length;
          const disconnectedDevices = entities.filter(
            (device: Record<string, unknown>) =>
              device.status === "disconnected" || device.connectionState === "disconnected"
          ).length;
          const errorDevices = entities.filter(
            (device: Record<string, unknown>) =>
              device.status === "error" || device.hasError === true
          ).length;

          return [
            {
              title: "Total Devices",
              value: () => totalDevices.toString(),
              valueColor: "primary.main",
              variant: "with-icon" as const,
            },
            {
              title: "Connected",
              value: () => connectedDevices.toString(),
              valueColor: "success.main",
            },
            {
              title: "Disconnected",
              value: () => disconnectedDevices.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Errors",
              value: () => errorDevices.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
    },
  },
  {
    name: "plant-iot",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.plantIotStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalSensors = entities.length;
          const activeSensors = entities.filter(
            (sensor: Record<string, unknown>) =>
              sensor.status === "active" || sensor.isActive === true
          ).length;
          const alertingSensors = entities.filter(
            (sensor: Record<string, unknown>) =>
              sensor.hasAlert === true || sensor.alertStatus === "active"
          ).length;
          const offlineSensors = entities.filter(
            (sensor: Record<string, unknown>) =>
              sensor.status === "offline" || sensor.isOnline === false
          ).length;

          return [
            {
              title: "Total Sensors",
              value: () => totalSensors.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeSensors.toString(),
              valueColor: "success.main",
            },
            {
              title: "Alerting",
              value: () => alertingSensors.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Offline",
              value: () => offlineSensors.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["plantId", "deviceName"],
          sortDirection: { plantId: "ASC", deviceName: "ASC" },
        },
      },
    },
  },
];